module.exports = __webpack_public_path__ + "static/img/01.39523a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour2/01.jpg
// module id = nd6E
// module chunks = 0